export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14075.5880a0c3.jpg";